import styled from '@emotion/styled'
import { Theme } from '@emotion/react'

interface L2TabularListRootProps {
	columnCount?: number,
	gridTemplateColumns?: string,
}

export const L2TabularListRoot = styled.div<L2TabularListRootProps>(({theme, columnCount, gridTemplateColumns}) => {
	if(!gridTemplateColumns) {
		gridTemplateColumns = `repeat(${columnCount}, auto)`
	}
	return {
		display: 'grid',
		gridTemplateColumns: `[rowstartln] ${gridTemplateColumns} [rowendln]`,
	}
})

export const L2TabularListHeader = styled.div(({theme}) => ({
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	alignContent: 'center',
	alignItems: 'center',
	backgroundColor: theme.colors.second,
	borderTopLeftRadius: theme.borderRadius,
	borderTopRightRadius: theme.borderRadius,
	fontSize: '14px',
	color: theme.colors.tableLabel,
	fontWeight: 600,
	'> *': {
		padding: theme.spacing(1.5, 2),
	},
}))

export const L2TabularListContent = styled.div(({theme}) => ({
	backgroundColor: theme.colors.white,
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	border: `1px solid ${theme.colors.lines}`,
	borderTop: 0,
	borderBottomLeftRadius: theme.borderRadius,
	borderBottomRightRadius: theme.borderRadius,
	overflow: 'clip',
	minHeight: theme.spacing(4),
}))

export const L2TabularListContentNoHeader = styled.div(({theme}) => ({
	backgroundColor: theme.colors.white,
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	overflow: 'clip',
	minHeight: theme.spacing(4),
	'> *:first-child': {
		borderTop: '0 !important',
	},
}))

export const L2TabularListActions = styled.div(({theme}) => ({
	marginTop: theme.spacing(3),
	display: 'flex',
	flexDirection: 'row',
	columnGap: theme.spacing(2),
}))
